module.exports = __webpack_public_path__ + "static/tataki-b6f121616167a1ba781f5f3162353124.jpg";